<template>
  <div style="background-color: #f1f3f6;">
    <div>
      <div id="warehouse-across-tab-header">
        <div class="flexbox header">
          <div class="warehouse-across-title-icon ">
            <img :src="iconUrl" alt="" class="img-responsive">
          </div>
          <h2 class="warehouse-across-title mr-r-10">ACROSS倉庫</h2>
          <nav-tabs
            @handleShowBackdrop="handleShowBackdrop"
            @handleCloseBackdrop="handleCloseBackdrop"
            :tab="tab">
          </nav-tabs>
        </div>
      </div>
      <div class="modal-backdrop" id="modal-backdrop" v-show="isShowBackdrop"></div>
    </div>
    <div id="warehouse-across-tab-content" style="padding: 0 40px;">
      <breadcrumb :tab="tab" :subTab="subTab"></breadcrumb>
      <tab-content :tab="tab" :subTab="subTab"></tab-content>
    </div>
  </div>
</template>

<script>
import msg from '@/common/msg'
import NavTabs from './NavTabs'
import Breadcrumb from './components/Breadcrumb'
import TabContent from './TabContent'
import SettingService from '@/services/settingservice'
import tabs from '@/common/warehouse-across-tabs'

export default {
  components: {
    NavTabs,
    Breadcrumb,
    TabContent
  },
  data () {
    return {
      tab: null,
      subTab: null,
      loader: null,
      isShowBackdrop: false
    }
  },
  computed: {
    isMaintenance () {
      return this.$store.getters.getUser.maintenanceFlg
    },
    allowTabs () {
      return tabs.filter(tab => !tab.disabled).map(tab => tab.id)
    },
    allowSubTabs () {
      const childTabs = tabs.flatMap(tab => tab.childs.map(child => child.id))
      const editTabs = ['edit-direct-delivery', 'edit-multi-channel', 'edit-stock-crew']
      return [...childTabs, ...editTabs]
    },
    iconUrl () {
      return this.$store.getters.getWareHouseIcons['salmonAcross']
    },
    isUsedAcross () {
      return this.$store.getters.getUser.acrossAgreeFlg
    }
  },
  created () {
    if (this.isUsedAcross === '0') {
      this.$router.push('/not-found')
      return
    }
    this.tab = this.$route.params.tab
    this.subTab = this.$route.params.subTab
    if ((this.tab && !this.allowTabs.includes(this.tab)) || (this.subTab && !this.allowSubTabs.includes(this.subTab))) {
      if (this.tab !== 'expense-details') {
        this.tab = 'expense-details'
        this.subTab = 'shipment-record'
        this.$router.push('/warehouse-across/expense-details/shipment-record')
      }
    }
  },
  mounted () {
    this.getSellerInfo()
    document.addEventListener('click', this.handleButtonClick, true)
    this.$events.listen('handleError', (err, modalWidth = 400) => {
      if (err === msg.maintenance) {
        this.$store.commit('toggleMaintenanceModal', {
          show: true
        })
        return
      }
      this.$store.commit('toggleModal', {
        show: true,
        message: err,
        modalWidth: modalWidth
      })
    })
  },
  methods: {
    async getSellerInfo () {
      await SettingService.getSellerInformation()
        .then(response => {
          this.$store.commit('setUser', response.seller)
          if (this.$store.getters.getUser.acrossAgreeFlg === '0') {
            this.$router.push('/not-found')
            return false
          }
        })
    },
    handleShowBackdrop () {
      this.isShowBackdrop = true
      $('.header').attr('style', 'background-color: #fff')
    },
    handleCloseBackdrop () {
      this.isShowBackdrop = false
      $('.header').attr('style', 'background-color: #f1f3f6')
    },
    handleButtonClick (event) {
      if (event.target.classList.contains('check-maintenance')) {
        if (this.isMaintenance) {
          this.$store.commit('toggleMaintenanceModal', {
            show: true
          })
          event.stopImmediatePropagation()
        }
      }
    }
  },
  watch: {
    $route (to, from) {
      const toTab = to.params.tab
      const subTab = to.params.subTab
      if ((this.tab && !this.allowTabs.includes(this.tab)) || (this.subTab && !this.allowSubTabs.includes(this.subTab))) {
        if (from.params.tab !== 'expense-details') {
          this.$router.push('/warehouse-across/expense-details/shipment-record')
        }
      } else {
        this.tab = toTab
        this.subTab = subTab
      }
    }
  },
  beforeDestroy () {
    this.$events.remove('done')
    this.loader && this.loader.hide()
    document.removeEventListener('click', this.handleButtonClick, true)
  }
}
</script>

<style scoped>
#warehouse-across-tab-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
#warehouse-across-tab-header .warehouse-across-title-icon {
  width: 40px;
  margin-right: 20px;
}
.modal-backdrop {
  z-index: 2;
  opacity: 0.4;
}
#warehouse-across-tab-header > .header {
  padding: 20px 40px;
  flex-wrap: wrap;
  z-index: 3;
  background-color: #f1f3f6;
  width: 100%;
}
</style>
<style>
.modal-open {
  overflow: unset;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/Warehouses.vue